export default __webpack_public_path__ + "static/rule-03-stand-straight-9bf906a8f0fdd71a1ca816232b885a9c.png";